/* @flow weak */
import Config from 'Config';
import _ from 'lodash';
import idx from 'idx';
import scriptjs from 'scriptjs';

const URL = `https://maps.googleapis.com/maps/api/js?key=${
  Config.Environment.GOOGLE_PLACES_API_KEY
}&libraries=places`;

let loadId = null;

export default function() {
  const Autocomplete = idx(window, w => w.google.maps.places.Autocomplete);
  if (Autocomplete) {
    return Promise.resolve(Autocomplete);
  }

  if (!loadId) {
    scriptjs(URL, (loadId = _.uniqueId('googlePlaces')));
  }

  return new Promise(resolve => {
    scriptjs.ready(loadId, () => {
      const Auto = idx(window, w => w.google.maps.places.Autocomplete);
      if (!Auto) {
        loadId = null;
        throw new Error('No Autocomplete found after loading places script');
      }
      resolve(Auto);
    });
  });
}
